/* Text-only navigation: hover reveals submenus; links navigate directly. */
(() => {
  if (window.zytaNavigationV3) return;
  const roots = new Set();
  function bind(root) {
    if (root.dataset.navigationBound) return;
    root.dataset.navigationBound = 'true';
    const items = [...root.querySelectorAll('[data-nav-item]')];
    const close = (item, restoreFocus = false) => {
      const panel = item.querySelector('[data-nav-panel]');
      if (!panel || panel.hidden) return;
      const mainLink = item.querySelector('.nav-v3__link');
      const focusWasInside = panel.contains(document.activeElement);
      panel.hidden = true;
      item.classList.remove('is-open');
      mainLink.setAttribute('aria-expanded', 'false');
      if (restoreFocus || focusWasInside) mainLink.focus({ preventScroll: true });
    };
    const closeAll = (except) => items.forEach(item => { if (item !== except) close(item); });
    const open = (item) => {
      closeAll(item);
      item.querySelector('[data-nav-panel]').hidden = false;
      item.classList.add('is-open');
      const mainLink = item.querySelector('.nav-v3__link');
      mainLink.setAttribute('aria-expanded', 'true');
    };
    items.forEach(item => {
      const mainLink = item.querySelector('.nav-v3__link');
      const panel = item.querySelector('[data-nav-panel]');
      if (!panel || !mainLink) return;
      item.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch' && matchMedia('(hover: hover)').matches) open(item);
      });
      item.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'touch' && matchMedia('(hover: hover)').matches) close(item);
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) close(item);
      });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          close(item, true);
        } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && event.target === mainLink) {
          event.preventDefault();
          open(item);
          const links = panel.querySelectorAll('a[href]');
          const target = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
          if (target) target.focus();
        }
      });
      item.querySelectorAll('a[href]').forEach(link => link.addEventListener('click', () => close(item)));
    });
    root.addEventListener('pointerover', event => {
      if (event.pointerType !== 'touch' && !event.target.closest('[data-nav-item]')) closeAll();
    });
    roots.add({ root, closeAll });
  }
  function init(scope = document) {
    if (scope.matches && scope.matches('[data-navigation-v3]')) bind(scope);
    scope.querySelectorAll('[data-navigation-v3]').forEach(bind);
  }
  document.addEventListener('pointerdown', event => {
    roots.forEach(state => {
      if (!state.root.isConnected) roots.delete(state);
      else if (!state.root.contains(event.target)) state.closeAll();
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.zytaNavigationV3 = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
